<template>
  <div>
    <template v-if="joboffer && jobDetails">
      <div class="preview-label">
        <v-btn>Vorschau</v-btn>
      </div>
      <job-row-view
        v-if="joboffer && jobDetails"
        :apiUrl="apiUrl"
        :joboffer="joboffer"
        :jobDetails="jobDetails"
        :slug="slug"
        :class="`job-preview company_${currentCompanyId}`"
        preview
      />
    </template>

    <template v-else>
      <v-row>
        <v-col cols="12" sm="6" offset-sm="3">
          <div style="height: calc(100vh - 250px); padding-top: 250px">
            <v-progress-linear
              indeterminate
              rounded
              color="primary"
              height="10"
            />
          </div>
        </v-col>
      </v-row>
    </template>
  </div>
</template>

<script>
import { mapActions, mapMutations, mapState, mapGetters } from 'vuex';

import jobRowView from '@/components/jobDetails/job-details-column-view.vue';

export default {
  data: () => ({
    joboffer: null,
    jobDetails: null
  }),

  watch: {
    $route() {
      this.initialize();
    }
  },

  computed: {
    ...mapState('companyModule', {
      slug: 'slug',
      currentCompanyId: 'currentCompanyId'
    }),

    ...mapGetters('companyModule', {
      apiUrl: 'currentCompanyApiUrl'
    })
  },

  async mounted() {
    this.setCurrentJob({ joboffer: null, jobDetails: null });
    await this.initialize();
  },

  methods: {
    ...mapActions('jobsModule', {
      loadJobDetails: 'loadJobDetails',
      loadJob: 'loadJob',
      loadJobs: 'loadJobs'
    }),

    ...mapMutations({
      setHeroClaim: 'setHeroClaim',
      setCurrentJob: 'jobsModule/setCurrentJob',
      setCompanyId: 'companyModule/setCurrentCompanyId'
    }),

    async initialize() {
      const jobId = this.$route.params.jobId;
      const token = this.$route.params.token;
      const job = await this.loadJob({
        jobofferId: jobId,
        token: token
      });

      this.joboffer = job;
      this.setHeroClaim(job.name);
      document.title = `Vorschau: ${this.localize(job.name)}`;

      const advertType = this.$route.query.advertType;
      const response = await this.loadJobDetails({
        slug: this.slug,
        jobofferId: jobId,
        isInternal: advertType?.toString() === '2'
      });

      this.jobDetails = response;
      this.$nextTick(() => {
        this.setCompanyId(response.companyId);
      });

      this.setCurrentJob({ joboffer: job, jobDetails: response });
    }
  },

  components: {
    jobRowView
  }
};
</script>
<style>
.job-preview a,
.job-preview button {
  pointer-events: none !important;
}

.job-preview > .row {
  padding-top: 5%;
  background-color: white;
  background-clip: content-box;
}

.job-preview > .row > .job-details__columns__right-col {
  padding-right: 5%;
  padding-bottom: 5%;
}

.job-preview > .row > :not(.job-details__columns__right-col) {
  padding-left: 5%;
  padding-bottom: 5%;
}

.preview-label {
  position: absolute;
  left: 50%;
  transform: translate(-50%, 100%) scale(1.2);
}

.preview-label button.v-btn.v-btn--has-bg {
  pointer-events: none !important;
}

#main-content:has(.job-preview) {
  background-color: gainsboro !important;
}
</style>
